module.exports = __webpack_public_path__ + "static/img/buyer_logo_25.23a8b98.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/buyer/buyer_logo_25.jpg
// module id = o9vT
// module chunks = 0